import api from './api'
import type {
  EmailRule,
  EmailRulesResponse,
  EmailRuleCreate,
  EmailRuleUpdate,
} from '@/types/emailRule'

export async function getEmailRules(params?: {
  status?: string
  vendor?: string
}): Promise<EmailRulesResponse> {
  const response = await api.get<EmailRulesResponse>('/email-rules', { params })
  return response.data
}

export async function getEmailRule(id: number): Promise<EmailRule> {
  const response = await api.get<EmailRule>(`/email-rules/${id}`)
  return response.data
}

export async function createEmailRule(data: EmailRuleCreate): Promise<EmailRule> {
  const response = await api.post<EmailRule>('/email-rules', data)
  return response.data
}

export async function updateEmailRule(id: number, data: EmailRuleUpdate): Promise<EmailRule> {
  const response = await api.put<EmailRule>(`/email-rules/${id}`, data)
  return response.data
}

export async function deleteEmailRule(id: number): Promise<void> {
  await api.delete(`/email-rules/${id}`)
}
